import { Form } from "react-bootstrap";
import { useCallback, useContext, useEffect } from "react";
import { NewTableContext } from ".";

interface ITableFilterProps extends React.HTMLProps<HTMLElement>{

}
interface ITableFilterInputProps extends React.HTMLProps<HTMLElement>{
  label: string;
  dataField: string;
  value?: any;
}

interface ITableFilterSelectProps extends ITableFilterInputProps{
  enableAll?: boolean;
}


function TableFilterInput({label,dataField, value = null}:ITableFilterInputProps){
  const { setFilter } = useContext(NewTableContext);

  const change = useCallback((value: any)=>{
    let filter:any = {};
    filter[dataField] = value;
    if(setFilter)setFilter(filter);
  },[setFilter,dataField])

  useEffect(()=>{
    if(value)change(value)
  },[value,change])
  return (
    <Form.Group className="new-table-filters-item">
      <Form.Label>{label}:</Form.Label>
      <Form.Control size="sm" onChange={({currentTarget})=>{
        change(currentTarget.value);
      }} defaultValue={value}/>
    </Form.Group>
  );
}

function TableFilterSelect({label,dataField,children, value, enableAll}:ITableFilterSelectProps){
  const { setFilter } = useContext(NewTableContext);

  const change = useCallback((value: any)=>{
    let filter:any = {};
    filter[dataField] = value;
    if(setFilter)setFilter(filter);
  },[setFilter,dataField]);

  useEffect(()=>{
    if(value)change(value)
  },[value,change])
  return (
    <Form.Group className="new-table-filters-item">
      <Form.Label>{label}:</Form.Label>
      <Form.Select size="sm" defaultValue={value} onChange={({currentTarget})=>{
        currentTarget.blur()
        change(currentTarget.value);
      }}>
        {enableAll?(
          <option value="all">Todos</option>
        ):null}
        {children}
      </Form.Select>
    </Form.Group>
  );
}


function TableFilter({...props}:ITableFilterProps){
  return (
    <div className="new-table-filters">
      {props.children}
    </div>
  );
}

export default Object.assign(TableFilter,{
  Input: TableFilterInput,
  Select: TableFilterSelect
});